/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
import { fork, take, call, race } from "typed-redux-saga";
import { getType } from "typesafe-actions";
import { rootActions } from "..";
import { fetchStaticData, liveRefreshWatcher } from "./sagas";

export function* machinePerformanceRootSaga() {
  yield* fork(machinePerformanceRefreshLoop);
}

function* machinePerformanceRefreshLoop() {
  while (true) {
    yield* call(fetchStaticData);
    yield* race({
      liveRefreshWatcher: call(liveRefreshWatcher),
      cancel: take([getType(rootActions.session.startEndUpdated)]),
    });
  }
}
